import { render, staticRenderFns } from "./sectionCard.vue?vue&type=template&id=383fe001&scoped=true"
import script from "./sectionCard.vue?vue&type=script&lang=js"
export * from "./sectionCard.vue?vue&type=script&lang=js"
import style0 from "./sectionCard.vue?vue&type=style&index=0&id=383fe001&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383fe001",
  null
  
)

export default component.exports